<div class="col-12 mainContent">
    <div class="col-3 left">
        <div id="scrollfix">
            <left-select [onChange]='true' (ChangeEvt)="SetTempQuery($event)"></left-select>
            <div class="btn" (click)="AddToTag()">加入搜尋條件</div>
        </div>
    </div>
    <div class="col-9 right">
        
        <div class="case">
            <h1>採購案活動列表 </h1>

            <div class="term" *ngIf="TagGroup.length > 0">
                <ng-container *ngFor="let item of TagGroup;let _g = index;">
                    <div *ngIf="item.tag.length > 0" class="tag {{ (_g == 0) ? 'first' : '' }}" >
                        <label>{{item.name}}</label>
                        <p>
                            <ng-container *ngFor="let _child of item.tag;">
                                <label>{{_child.name}}<i class="icon icon-close" (click)="RemoveTag(_child.tag_index)">&#xe802;</i></label>
                            </ng-container>
                        </p>
                    </div>
                </ng-container>
            </div>
            <div style="margin-bottom:2rem;"></div>

            <div class="content animated fadeIn" *ngIf="Data">

                <empty *ngIf="Data.length == 0"></empty>

                <ng-container *ngFor="let item of Data">
                    <div class="card {{item.statusClass}}">
                        <div class="item" routerLink="/activity/{{item.id}}">
                            <div class="status"><span>{{item.statusName}}</span></div>
                            <span class="date {{(item.is_new) ? 'lasted' : ''}}">{{item.eventShortDate}}</span>
                            <label>{{item.name}}</label>
                            <p>
                                <span class="date">報名日期｜{{item.enrollDate}}</span>
                                <span class="info">{{item.typeName}}</span>
                            </p>
                            <a routerLink="/activity/{{item.id}}"><span class="view">查看詳情</span></a>
                        </div>
                    </div>
                </ng-container>
                <pagination *ngIf="PagerData" [Pager]="PagerData" (PageSetEvt)="SetPage($event)"></pagination>

                
            </div>
        </div>
    </div>
</div>